export enum ButtonSizeType {
  sm = "sm",
  md = "md",
  fit = "fit"
}
